import $ from 'jquery';
import twzSelect from './formSelect.js';

window.addEventListener('DOMContentLoaded', () => initSelect() );
$(document).on("sf:ajaxfinish", ".searchandfilter", () => initSelect() );

const initSelect = () => {
    if(document.querySelector('.twz-training-filters__items select') ) {
        const selectfields = document.querySelectorAll('.twz-training-filters__items select');
        new twzSelect(selectfields);
    }
}